import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { User } from "../../models/user.model";

interface UserState {
    users: User[];
    loading: boolean;
    currentUser: User | null;
}

const initialState: UserState = {
    users: [],
    loading: false,
    currentUser: null
};

const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        getAllUsers: (state) => {
            state.loading = true;
        },
        getAllUsersSuccess: (state, action: PayloadAction<User[]>) => {
            state.users = action.payload;
            state.loading = false;
        },
        getAllUsersFailed: (state) => {
            state.loading = false;
        },
        createUser: (state) => {
            state.loading = true;
        },
        createUserSuccess: (state, action: PayloadAction<User>) => {
            state.users = [action.payload, ...state.users];
            state.loading = false;
        },
        createUserFailed: (state) => {
            state.loading = false;
        },
        updateUser: (state) => {
            state.loading = true;
        },
        updateUserSuccess: (state, action: PayloadAction<User>) => {
            const index = state.users.findIndex(user => user._id === action.payload._id);
            if (index !== -1) {
                state.users[index] = action.payload;
            }
            state.loading = false;
        },
        updateUserFailed: (state) => {
            state.loading = false;
        },
        deleteUser: (state) => {
            state.loading = true;
        },
        deleteUserSuccess: (state, action: PayloadAction<string>) => {
            state.users = state.users.filter(user => user._id !== action.payload);
            state.loading = false;
        },
        deleteUserFailed: (state) => {
            state.loading = false;
        },
    }
});

export const {
    getAllUsers,
    getAllUsersSuccess,
    getAllUsersFailed,
    createUser,
    createUserSuccess,
    createUserFailed,
    updateUser,
    updateUserSuccess,
    updateUserFailed,
    deleteUser,
    deleteUserSuccess,
    deleteUserFailed,
} = userSlice.actions;

export default userSlice.reducer; 